import React from 'react';

export default () => {
  return <div>
    <h3>Oops, 404!</h3>
    <div><a href='/'>Home</a></div>
  </div>
}
